// Routes.jsx
import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { Global } from "../helpers/Global";
import { PublicLayout } from "../layout/public/PublicLayout";
import { PrivateLayout } from "../layout/private/PrivateLayout";
import { AuthProvider } from "../context/AuthProvider";
import { PrivateRoute } from "./privateRoute";

// Páginas públicas
import { LoginDNI } from "../user/LoginDNI";
import { LoginMail } from "../user/LoginMail";
import { SolicitarResetPassword } from "../user/solicitarResetPassword";
import { ResetearPassword } from "../user/resetearPassword";

// Páginas comunes
import { LogOut } from "../user/logout";
import { InicioPage } from "../pages/inicio";
import { ConfigurarAlertas } from "../alertas/configurarAlertas.jsx";

// Jornadas
import { JornadaPage } from "../jornada/jornadaPage";
import { JornadasAdmin } from "../jornada/jornadaAdmin";
import { JornadasGerente } from "../jornada/jornadaGerente";
import { MisJornadasFinalizadas } from "../jornada/misJornadasFinalizadas";
import { JornadasProcesoAdmin } from "../jornada/jornadaProcesoAdmin";
import { JornadasProcesoGerente } from "../jornada/jornadaProcesoGerente";
import { CrearJornadaManualAdmin } from "../jornada/crearJornadaManualAdmin";
import { CrearJornadaManualGerente } from "../jornada/crearJornadaManualGerente";
import { FinalizarJornadaManualAdmin } from "../jornada/finalizarJornadaAdmin";
import { FinalizarJornadaManualGerente } from "../jornada/finalizarJornadaGerente";
import { JornadaCentros } from "../jornada/jornadaCentros.jsx";

// Intervenciones
import { IntervencionPage } from "../intervenciones/intervencionPage";
import { IntervencionesAdmin } from "../intervenciones/intervencionesAdmin";
import { IntervencionesGerente } from "../intervenciones/intervencionesGerente";
import { InterProcesoGerente } from "../intervenciones/InterProcesoGerente";
import { InterProcesoAdmin } from "../intervenciones/interProcesoAdmin.jsx";
import { MisIntervencionesFinalizadas } from "../intervenciones/misIntervencionesFinalizadas";
import { CrearIntervencionManualAdmin } from "../intervenciones/crearInterManualAdmin";
import { CrearIntervencionManualGerente } from "../intervenciones/crearInterManualGerente";
import { FinalizarInterManualAdmin } from "../intervenciones/finalizarInterAdmin";
import { FinalizarInterManualGerente } from "../intervenciones/finalizarInterGerente";

// Calendario
import { MiCalendario } from "../calendario/miCalendario";
import { CalendarioAdmin } from "../calendario/calendarioAdmin";
import { CrearPlantillaTurno } from "../calendario/crearPlantillaTurno.jsx";
import { PlantillaTurnoAdmin } from "../calendario/plantillaTurnoAdmin.jsx";
import { CalendarioGlobal } from "../calendario/calendarioGlobal.jsx";

// Órdenes
import { CrearOrden } from "../ordenes/crearOrden";
import { OrdenAdmin } from "../ordenes/ordenAdmin";

// Tareas
import { CrearTarea } from "../tareas/crearTarea.jsx";
import { TableroTareasPersonal } from "../tareas/tableroTareasPersonal.jsx"
import { TableroTareasDepartamento } from "../tareas/tableroTareasDepartamento.jsx"
import { DashboardGlobal} from "../tareas/dashboardGlobal.jsx"

// Clientes
import { CrearCliente } from "../clientes/agregarCliente";
import { ClientesAdmin } from "../clientes/clientesAdmin";
import { CentrosEmpleado } from "../clientes/centrosEmpleado.jsx";

// Usuarios
import { GestionUsuarios2 } from "../user/gestionUsuarios2.jsx";
import { RegistrarUsuarioDNI } from "../user/registrarUsuarioDNI";
import { RegistrarUsuarioMail } from "../user/registrarUsuarioMail";
import { Organigrama } from "../user/organigrama";
import { CambiarContrasena } from "../user/cambiarContrasena";

// Departamentos
import { CrearDepartamento } from "../departamentos/crearDepartamento.jsx";
import { DepartamentosAdmin } from "../departamentos/departamentoAdmin.jsx";

//ControSIL
import { GestionNodoSIL } from "../controlsil/gestionNodoSIL.jsx";
import { CrearReporteSIL } from "../controlsil/crearReporteSIL.jsx";
import { PanelReportesSIL } from "../controlsil/panelReporteSil.jsx";

// Logs
import { LogsAdmin } from "../user/logsAdmin";

// Footer
import { Footer } from "../layout/Footer";

export const Rutas = () => {
  // Solo "dni" | "mail" (por defecto, "mail")
  const isMail = String(Global?.loginPrimary || "mail").toLowerCase() === "mail";

  const LoginComponent = isMail ? LoginMail : LoginDNI;
  const RegistrarUsuarioComponent = isMail ? RegistrarUsuarioMail : RegistrarUsuarioDNI;

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>

          {/* ==== RUTAS PÚBLICAS ==== */}
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<LoginComponent />} />
            <Route path="login" element={<LoginComponent />} />
            <Route path="olvide-password" element={<SolicitarResetPassword />} />
            <Route path="resetear-password" element={<ResetearPassword />} />
          </Route>

          {/* ==== RUTAS PRIVADAS ==== */}
          <Route path="/app" element={<PrivateLayout />}>

            {/* Comunes */}
            <Route index element={<PrivateRoute><InicioPage /></PrivateRoute>} />
            <Route path="inicio" element={<PrivateRoute><InicioPage /></PrivateRoute>} />
            <Route path="intervencion" element={<PrivateRoute><IntervencionPage /></PrivateRoute>} />
            <Route path="misIntervenciones" element={<PrivateRoute><MisIntervencionesFinalizadas /></PrivateRoute>} />
            <Route path="jornada" element={<PrivateRoute><JornadaPage /></PrivateRoute>} />
            <Route path="misJornadas" element={<PrivateRoute><MisJornadasFinalizadas /></PrivateRoute>} />
            <Route path="miCalendario" element={<PrivateRoute><MiCalendario /></PrivateRoute>} />
            <Route path="listaCentros" element={<PrivateRoute><CentrosEmpleado /></PrivateRoute>} />
            <Route path="cambiarContrasena" element={<PrivateRoute><CambiarContrasena /></PrivateRoute>} />
            <Route path="misAlertas" element={<PrivateRoute><ConfigurarAlertas /></PrivateRoute>} />
            <Route path="logout" element={<PrivateRoute><LogOut /></PrivateRoute>} />

            {/* Intervenciones */}
            <Route path="intervencionesAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><IntervencionesAdmin /></PrivateRoute>} />
            <Route path="interProcesoAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><InterProcesoAdmin /></PrivateRoute>} />
            <Route path="crearInterAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><CrearIntervencionManualAdmin /></PrivateRoute>} />
            <Route path="finalizarInterAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><FinalizarInterManualAdmin /></PrivateRoute>} />
            <Route path="intervencionesGerente" element={<PrivateRoute rolesPermitidos={["gerente"]}><IntervencionesGerente /></PrivateRoute>} />
            <Route path="interProcesoGerente" element={<PrivateRoute rolesPermitidos={["gerente"]}><InterProcesoGerente /></PrivateRoute>} />
            <Route path="crearInterGerente" element={<PrivateRoute rolesPermitidos={["gerente"]}><CrearIntervencionManualGerente /></PrivateRoute>} />
            <Route path="finalizarInterGerente" element={<PrivateRoute rolesPermitidos={["gerente"]}><FinalizarInterManualGerente /></PrivateRoute>} />

            {/* Jornadas */}
            <Route path="jornadasAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><JornadasAdmin /></PrivateRoute>} />
            <Route path="jornadasProcesoAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><JornadasProcesoAdmin /></PrivateRoute>} />
            <Route path="crearJornadasAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><CrearJornadaManualAdmin /></PrivateRoute>} />
            <Route path="finalizarJornadasAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><FinalizarJornadaManualAdmin /></PrivateRoute>} />
            <Route path="jornadasCentro" element={<PrivateRoute rolesPermitidos={["admin","gerente"]}><JornadaCentros /></PrivateRoute>} />
            <Route path="jornadasGerente" element={<PrivateRoute rolesPermitidos={["gerente"]}><JornadasGerente /></PrivateRoute>} />
            <Route path="jornadasProcesoGerente" element={<PrivateRoute rolesPermitidos={["gerente"]}><JornadasProcesoGerente /></PrivateRoute>} />
            <Route path="crearJornadasGerente" element={<PrivateRoute rolesPermitidos={["gerente"]}><CrearJornadaManualGerente /></PrivateRoute>} />
            <Route path="finalizarJornadasGerente" element={<PrivateRoute rolesPermitidos={["gerente"]}><FinalizarJornadaManualGerente /></PrivateRoute>} />

            {/* Calendario */}
            <Route path="calendarioAdmin" element={<PrivateRoute rolesPermitidos={["admin","gerente"]}><CalendarioAdmin /></PrivateRoute>} />
            <Route path="crearPlantillaTurno" element={<PrivateRoute rolesPermitidos={["admin","gerente"]}><CrearPlantillaTurno /></PrivateRoute>} />
            <Route path="plantillaTurnoAdmin" element={<PrivateRoute rolesPermitidos={["admin","gerente"]}><PlantillaTurnoAdmin /></PrivateRoute>} />
            <Route path="global" element={<PrivateRoute rolesPermitidos={["admin","gerente"]}><CalendarioGlobal /></PrivateRoute>} />

            {/* Órdenes */}
            <Route path="crearOrden" element={<PrivateRoute rolesPermitidos={["admin"]}><CrearOrden /></PrivateRoute>} />
            <Route path="ordenAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><OrdenAdmin /></PrivateRoute>} />

            {/* Clientes */}
            <Route path="crearCliente" element={<PrivateRoute rolesPermitidos={["admin"]}><CrearCliente /></PrivateRoute>} />
            <Route path="clientesAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><ClientesAdmin /></PrivateRoute>} />

            {/* Tareas */}
            <Route path="crearTarea" element={<PrivateRoute rolesPermitidos={["admin"]}><CrearTarea /></PrivateRoute>} />
            <Route path="tableroPersonal" element={<PrivateRoute rolesPermitidos={["admin"]}><TableroTareasPersonal /></PrivateRoute>} />
            <Route path="tableroDepartamento" element={<PrivateRoute rolesPermitidos={["admin"]}><TableroTareasDepartamento /></PrivateRoute>} />
            <Route path="dashboard" element={<PrivateRoute rolesPermitidos={["admin"]}><DashboardGlobal /></PrivateRoute>} />

            {/* Usuarios */}
            <Route path="crearUsuario" element={<PrivateRoute rolesPermitidos={["admin"]}><RegistrarUsuarioComponent /></PrivateRoute>}/>
            <Route path="usuariosAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><GestionUsuarios2 /></PrivateRoute>} />
            <Route path="organigrama" element={<PrivateRoute rolesPermitidos={["admin"]}><Organigrama /></PrivateRoute>} />

            {/* Departamentos */}
            <Route path="crearDepartamento" element={<PrivateRoute rolesPermitidos={["admin"]}><CrearDepartamento /></PrivateRoute>}/>
            <Route path="departamentosAdmin" element={<PrivateRoute rolesPermitidos={["admin"]}><DepartamentosAdmin /></PrivateRoute>} />
            <Route path="organigrama" element={<PrivateRoute rolesPermitidos={["admin"]}><Organigrama /></PrivateRoute>} />

            {/* ControlSIL */}
            <Route path="GestionControlSIL" element={<PrivateRoute rolesPermitidos={["admin"]}><GestionNodoSIL /></PrivateRoute>}/>
            <Route path="crearReporteSIL" element={<PrivateRoute rolesPermitidos={["admin"]}><CrearReporteSIL /></PrivateRoute>}/>
            <Route path="panelControlSIL" element={<PrivateRoute rolesPermitidos={["admin"]}><PanelReportesSIL /></PrivateRoute>}/>


            {/* Logs */}
            <Route path="logs" element={<PrivateRoute rolesPermitidos={["admin"]}><LogsAdmin /></PrivateRoute>} />
          </Route>

          {/* ==== ERROR 404 ==== */}
          <Route
            path="*"
            element={
              <div className="error-404">
                <h1>Error 404</h1>
                <p>La página que buscas no existe.</p>
                <a href="/">Volver al Inicio</a>
              </div>
            }
          />
        </Routes>
        <Footer />
      </AuthProvider>
    </BrowserRouter>
  );
};
